import LayoutWrapper from "@/components/LayoutWrapper/LayoutWrapper";
import PoweredByFooter from "@/components/PoweredByFooter";
import React from "react";
import { useTranslation } from "react-i18next";

const Error404: React.FC = () => {
  const { t } = useTranslation();
  return (
    <LayoutWrapper>
      <div className="p-4 rounded-3 bg-white">
        <h2 className="h3">
          <i className="fa-sharp fa-info-circle fa-light me-2"></i>{t("ErrorPage.404.Title")}
        </h2>
        <p className="text-muted fs-12 mb-0">
          {t("ErrorPage.404.Subtitle")}
        </p>
      </div>
      <PoweredByFooter />
    </LayoutWrapper>
  );
};

export default Error404;
